import { render } from "./InitiativesView.vue?vue&type=template&id=25fdcd7c&scoped=true"
import script from "./InitiativesView.vue?vue&type=script&lang=js"
export * from "./InitiativesView.vue?vue&type=script&lang=js"

import "./InitiativesView.vue?vue&type=style&index=0&id=25fdcd7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fdcd7c"]])

export default __exports__